import { cn } from "@/common/utils/css.utils";
import { ComponentProps } from "react";

type ActionLabelProps = ComponentProps<"label">;

/**
 * Label component for actions, such as {@link CheckBox} or @{link RadioButton}.
 *
 * @param className List of CSS classes to pass to the label tag.
 * @param props Rest of the label props.
 */
export const ActionLabel = ({ className, ...props }: ActionLabelProps) => {
  return (
    <label
      {...props}
      className={cn("font-body text-sm text-black", className)}
    />
  );
};
